import { useState, useContext } from 'react';
import _noop from 'lodash/noop';

import { ModalContext } from 'commons-ui';

import useService from '../../useService';
import { APPROVE_REJECT_KYC_STATUS, REJECT_REASONS } from '../../constants';
import { IUseContentProps } from '../types';

const useContent = (props: IUseContentProps) => {
	const { handleForceUpdate = _noop, kycId } = props;
	const { updateKYCStatus } = useService();

	const [showLoader, setShowLoader] = useState(false);
	const { setModalConfig } = useContext(ModalContext);

	const handleFormSubmit = async (submittedData: any) => {
		setShowLoader(true);
		const { selectedMessage, otherMessage } = submittedData;
		await updateKYCStatus({
			message: selectedMessage === REJECT_REASONS.OTHER ? otherMessage : selectedMessage,
			kycId,
			status: APPROVE_REJECT_KYC_STATUS.REJECTED
		});
		setShowLoader(false);

		handleForceUpdate();
		setModalConfig({ isOpen: false });
	};

	const handleFormCancel = () => {
		setModalConfig({ isOpen: false });
	};

	return {
		showLoader,
		setShowLoader,
		handleFormCancel,
		handleFormSubmit
	};
};

export default useContent;
